import React, { Component } from "react";
import { MuiGrid, MuiButton, MuiTypography, MuiAddCircle } from "../../ui/MaterialUIComponents";
import theme from "../../../assests/theme";
import { AvailabilityScheduleComponent } from "./AvailabilityScheduleComponent";

export class WeeklyAvailabilityScheduleComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { i18n } = this.props
    return (
      <MuiGrid container xs={12}>
        {/* <MuiGrid container xs={12} style={theme.gridTableStyle}> */}
        {this.props.isPreferredPeriod == false ?
          <MuiGrid container xs={12} direction="row" style={theme.tableHeaderStyle} >
            <MuiGrid item xs={5}>

              <MuiTypography style={theme.tableHeaderTextStyle}>
                {i18n.weeklyAvailabilitySchedule.days}
              </MuiTypography>
            </MuiGrid>

            <MuiGrid item xs={3}>

              <MuiTypography style={theme.tableHeaderTextStyle}>
                {i18n.weeklyAvailabilitySchedule.outFrom}
              </MuiTypography>
            </MuiGrid>
            <MuiGrid item xs>

              <MuiTypography style={theme.tableHeaderTextStyle}>
                {i18n.weeklyAvailabilitySchedule.outUntil}
              </MuiTypography>
            </MuiGrid>
          </MuiGrid>

          :

          /*
           * PREFERRED PERIODS
           */

          <MuiGrid container xs={12} direction="row" style={theme.tableHeaderStyle} >
            <MuiGrid item xs={5}>

              <MuiTypography style={theme.tableHeaderTextStyle}>    {i18n.weeklyAvailabilitySchedule.days}
              </MuiTypography>
            </MuiGrid>

            <MuiGrid item xs={3}>

              <MuiTypography style={theme.tableHeaderTextStyle}>     {i18n.weeklyAvailabilitySchedule.after}
              </MuiTypography>
            </MuiGrid>
            <MuiGrid item xs={3}>


              <MuiTypography style={theme.tableHeaderTextStyle}>  {i18n.weeklyAvailabilitySchedule.before}
              </MuiTypography>
            </MuiGrid>
          </MuiGrid>}

        {this.props.weeklyAvailabilitySchedule !== undefined && this.props.weeklyAvailabilitySchedule.map((schedule, index) => (
          <MuiGrid item xs={12} id="grid">
            <AvailabilityScheduleComponent
              {...this.props}
              schedule={schedule}
              index={index}
              removeWeeklyAvailabilitySchedule={this.props.removeWeeklyAvailabilitySchedule}
            />
          </MuiGrid>
        ))}

        <MuiGrid container xs={12} style={theme.gridActionContainerStyle} justify="center" alignItems="center" onClick={() => this.props.renderAvailabilityScheduleRow()}>
          <MuiGrid item>

            <MuiAddCircle style={{ color: theme.palette.orange }} fontSize='large' />

          </MuiGrid>
          <MuiGrid item>
            <MuiTypography
              style={theme.addMoreStyle}
            >
              {i18n.weeklyAvailabilitySchedule.addMore}
            </MuiTypography>
          </MuiGrid>
        </MuiGrid>
        {this.props.isPreferredPeriod == false &&
          <MuiGrid
            xs={12}
            container
            direction="row"
            justify="flex-end"
            alignItems="flex-end"
            style={{ padding: '5px' }}
          >
            <MuiGrid item xs={2}>
              <MuiButton
                id="cancel"
                style={theme.secondaryButtonStyle}
                onClick={() => this.props.onClickOfCancelInTeacherAvailabilitySchedule()}>
                {i18n.commonTexts.cancel}
              </MuiButton>
            </MuiGrid>
            <MuiGrid item xs={1}>
              <MuiButton
                id="ok"
                style={theme.primaryButtonStyle}
                onClick={() => this.props.onClickOfSaveInTeacherAvailabilitySchedule()}
              >
                {i18n.commonTexts.apply}
              </MuiButton>
            </MuiGrid>
          </MuiGrid>}
        {/* </MuiGrid> */}
      </MuiGrid>

    );
  }
}
export default WeeklyAvailabilityScheduleComponent;
